import React, {Component} from 'react';
import {Header, Button, Modal, Form, Grid} from 'semantic-ui-react';
import {FormattedNumber} from 'react-intl';
import PaymentDialog from "../my_bisttro/PaymentDialog";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import CustomDivider from "../extras/CustomDivider";
import Payments from "./Payments";
import {connect} from "react-redux";
import {paymentDialog} from "../../actions/PaymentDialogActions";
import {cancelSale} from "../../actions/AlertCancelSaleAction";
import SaleData from "../../data/SaleData";
import {showToast} from "../../actions/ToastAction";
import {totalSale} from "../../actions/SaleTotalAction";
import {paymentsDialog} from "../../actions/PaymentsDialogActions";
import localDB from "../../data/localDB";
import QuestionDialog from "../extras/QuestionDialog";
import DataService from "../../functions/DataService";

const moneyMask = createNumberMask({
    prefix: '$',
});

class ViewPayments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show_payment: props.show_payment,
            modal_amount: false,
            amount_error: false,
            sending_amount: false,
            amount: props.total_sale.amount,
            re_opening: false
        };
        this.handlePayment = this.handlePayment.bind(this);
        this.handlePaymentsDialog = this.handlePaymentsDialog.bind(this);
        this.props.paymentDialog(false);
        this.re_open_dialog = React.createRef();
    };

    update(payment) {
        this.setState({payment})
    };

    handlePayment() {
        this.props.paymentDialog(true);
    };

    handlePaymentsDialog() {
        this.props.paymentsDialog({open:true});
    };

    handleCancelSaleDialog = () => {
        this.props.cancelSale({show:true, id:this.props.sale.id});
    };

    handleCloseModalAmount = () => {
        this.setState({modal_amount:false, amount:this.props.total_sale.amount});
    };

    handleSubmitAmount = () => {
        let amount = parseFloat(this.state.amount ? this.state.amount : 0);
        if (amount >= 0) {
            this.setState({sending_amount: true});
            let data = {sale:this.props.sale.id, amount};
            SaleData.amount(data, (res) => {
                if(res && res.update){
                    this.props.totalSale(res.data);
                    this.handleCloseModalAmount();
                    this.setState({sending_amount: false, amount: res.data.amount});
                    this.props.showToast({message: 'Pago Fijo Aplicado!', type: 'success'});
                }else{
                    this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                }
                this.setState({sending_amount: false});
            });
        } else {
            this.setState({amount_error: true, sending_amount:false});
        }
    };

    handleAmountChange = (event) => {
        let amount = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        this.setState({amount});
        if(event.target.value.trim() === '' ){
            this.setState({amount_error: true});
        }else{
            this.setState({amount_error: false});
        }
    };

    handleReOpenSale = (id) => {
        this.setState({re_opening: true})
        DataService.put({}, `api/sales/re-open/${id}`, (res) => {
            if (res.re_open) {
                this.props.sale.state = 1
                this.props.showToast({message: 'Venta Reabierta!', type: 'success'});
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
            this.setState({re_opening: false})
        })
    }

    render() {
        return (
            <div>
                {this.props.total_sale.balance !== 0 ?
                    <Header as='h2' textAlign='center' style={{margin: '0px'}} color='orange'>
                        Saldo: $<FormattedNumber
                        value={this.props.total_sale.balance ? this.props.total_sale.balance:0}
                        currency="USD"
                        maximumFractionDigits={0}
                        minimumFractionDigits={0}
                    />
                    </Header> : null
                }
                <strong>Total Venta: $</strong>
                <FormattedNumber
                    value={this.props.total_sale.total_sale ? this.props.total_sale.total_sale:0}
                    currency="USD"
                    maximumFractionDigits={0}
                    minimumFractionDigits={0}
                />
                <br/>
                <strong>Descuento: $</strong>
                <label>
                    <FormattedNumber
                        value={this.props.total_sale.discount ? this.props.total_sale.discount:0}
                        currency="USD"
                        maximumFractionDigits={0}
                        minimumFractionDigits={0}
                    />
                </label>
                <label> ó {isNaN(Math.round(this.props.total_sale.discount/this.props.total_sale.total_sale*100)) ? 0:Math.round(this.props.total_sale.discount/this.props.total_sale.total_sale*100)}%</label>
                {localDB.check_feature('sale_item_discount') ? <React.Fragment>
                    <br/>
                    <strong>Otros Descuentos: $</strong>
                    <label>
                        <FormattedNumber
                            value={this.props.total_sale.items_discount}
                            currency="USD"
                            maximumFractionDigits={0}
                            minimumFractionDigits={0}
                        />
                    </label>
                </React.Fragment>:null}
                <br/>
                <strong>Abonos: $</strong>
                <FormattedNumber
                    value={this.props.total_sale.payments ? this.props.total_sale.payments:0}
                    currency="USD"
                    maximumFractionDigits={0}
                    minimumFractionDigits={0}
                />
                <br/>
                <strong>IVA: $</strong>
                <FormattedNumber
                    value={this.props.total_sale.taxes ? this.props.total_sale.taxes.reduce((a, b) => { return a + b.vlr_base; }, 0):0}
                    currency="USD"
                    maximumFractionDigits={1}
                    minimumFractionDigits={0}
                />
                {this.props.sale.state === 1 ? <Button fluid animated='fade' onClick={()=>{this.setState({modal_amount:true, amount:this.props.total_sale.amount})}}>
                    <Button.Content visible>Valor Fijo</Button.Content>
                    <Button.Content hidden>
                        $<FormattedNumber value={this.props.total_sale.amount} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                    </Button.Content>
                </Button>:null}
                {this.state.show_payment ?
                    <div>
                        <CustomDivider/>
                        <Button.Group widths='3' size='small'>
                            {this.props.sale.state === 1 ?
                                <Button primary onClick={this.handlePayment} content='Pagar'/> : null
                            }
                            <Button onClick={this.handlePaymentsDialog} content="Ver Pagos"/>
                            {(localDB.get('rol_access').includes('sale_edit_after_close') && this.props.sale.state !== 2 && localDB.get('store_security').can_cancel_sale) || (this.props.sale.state === 1 && localDB.get('store_security').can_cancel_sale) ? <Button onClick={this.handleCancelSaleDialog} content="Anular Venta"/>:null}
                            {localDB.get('rol_access').includes('sale_edit_after_close') && this.props.sale.state === 3 ? <Button onClick={() => this.re_open_dialog.current.open('Reabrir Venta', this.props.sale.id)} content="Reabrir Venta"/>:null}
                            {this.props.sale.state === 2 ? <Button primary content="Venta Anulada"/>:null}
                        </Button.Group>
                        <PaymentDialog sale={this.props.sale} type='sale' />
                        <Payments sale={this.props.sale}/>
                    </div> : null
                }
                <Modal open={this.state.modal_amount} size='tiny' dimmer='inverted' onClose={this.handleCloseModalAmount}>
                    <Modal.Header>Valor Fijo</Modal.Header>
                    <Modal.Content image>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input
                                                label='Valor'
                                                error={this.state.amount_error}
                                                children={
                                                    <MaskedInput
                                                        autoFocus
                                                        mask={moneyMask}
                                                        value={this.state.amount}
                                                        placeholder='Valor'
                                                        onChange={this.handleAmountChange}
                                                    />
                                                }
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseModalAmount} content="Cancelar"/>
                        <Button primary icon='save' disabled={this.state.sending_amount} loading={this.state.sending_amount} labelPosition='left' content='Aceptar' onClick={this.handleSubmitAmount}/>
                    </Modal.Actions>
                </Modal>
                <QuestionDialog ref={this.re_open_dialog} callbackConfirm={this.handleReOpenSale} message="Reabrir esta venta"/>
            </div>
        );
    }
}

function mapStateToProps(state){
    return{
        total_sale: state.get('total_sale'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        paymentDialog(product) {
            dispatch(paymentDialog(product));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        cancelSale(data){
            dispatch(cancelSale(data));
        },
        totalSale(data){
            dispatch(totalSale(data))
        },
        paymentsDialog(data){
            dispatch(paymentsDialog(data))
        },
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewPayments)



// WEBPACK FOOTER //
// ./src/components/sale/ViewPayments.js